
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("j51AU", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-GB.12acdb2f.js.map
